import dayjs from 'dayjs';
import { getTimezoneOffset, getTimezoneOffsetAdjusted } from '../get-timezone-offset';

export function getTimeAsStartOfDay(date: Date): number {
  return dayjs(date).startOf('day').valueOf();
}

export function getTimeAsEndOfDay(date: Date): number {
  return dayjs(date).endOf('day').valueOf();
}

const UTC_MIDDAY_HOUR = 12;

/**
 * UTC Midday is used to compensate for the difference timezone
 * in the case when only the date matters.
 * @param date
 */
export function getTimeAsUtcMidday(date: Date): number {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), UTC_MIDDAY_HOUR);
}

export function getTimeAsUtcStartOfDay(date: Date): number {
  return getTimeAsStartOfDay(date) - getTimezoneOffset();
}

export function getTimeUTC(date: Date | number): number {
  if (!date) {
    return null;
  } else if (typeof date === 'number') {
    return date - getTimezoneOffsetAdjusted();
  } else {
    return date.getTime() - getTimezoneOffsetAdjusted();
  }
}
